var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttentionBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "#F1F1F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.6663 35.9999C52.6663 45.2047 45.2044 52.6666 35.9997 52.6666C26.7949 52.6666 19.333 45.2047 19.333 35.9999C19.333 26.7952 26.7949 19.3333 35.9997 19.3333C45.2044 19.3333 52.6663 26.7952 52.6663 35.9999ZM33.4997 27.6666L34.333 37.6666H37.6663L38.4997 27.6666H33.4997ZM35.9997 45.1666C37.3804 45.1666 38.4997 44.0473 38.4997 42.6666C38.4997 41.2859 37.3804 40.1666 35.9997 40.1666C34.619 40.1666 33.4997 41.2859 33.4997 42.6666C33.4997 44.0473 34.619 45.1666 35.9997 45.1666Z",
    fill: "#EFA701"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttentionBig);
export default __webpack_public_path__ + "static/media/attention-big.74d591a52162694e859d5d35e795b795.svg";
export { ForwardRef as ReactComponent };